import request from "@/router/axios"
export const get = (params) => {
    return request({
        url: `/api/op/bill/get`,
        method: 'get',
        params
    })
}

export const evaluate = (data) => {
    return request({
        url: `/api/op/bill/evaluate`,
        method: 'post',
        data
    })
}


/**
 * 术前报告
 * @param
 * @returns {*}
 */
export const getReportList = (params) => {
    return request({
        url: `/api/op/bill/reportList`,
        method: 'get',
        params
    })
}

/**
 * 查询报告详情
 * @param reportId
 * @param reportType
 * @returns {*}
 */
export const getReportDetail = (reportId, reportType) => {
    return request({
        url: `/api/op/bill/reportDetail`,
        method: 'get',
        params: {
            reportId,
            reportType
        }
    })
}

export const syncBills = () => {
    return request({
        url: `/api/api/op/task/syncBills`,
        method: "post",
    });
};
